import { render } from "./Recipient.vue?vue&type=template&id=d3f11748&scoped=true"
import script from "./Recipient.vue?vue&type=script&lang=js"
export * from "./Recipient.vue?vue&type=script&lang=js"

import "./Recipient.vue?vue&type=style&index=0&id=d3f11748&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3f11748"]])

export default __exports__